import { http, type HttpClient } from './core/http-client';
import type { AuthSession, SessionUser, SignInResult, SocialProvider } from './models';

const audience = 'business';

export class AuthService {
  constructor(private readonly http: HttpClient) {}

  session = () => this.http.get<AuthSession | null>('/auth/session', { query: { audience } });

  login = (email: string, password: string) =>
    this.http.post<SignInResult>('/auth/login', { email, password, audience });

  register = (b: { email: string; password: string; displayName: string }) =>
    this.http.post<{ user: SessionUser }>('/auth/register', { ...b, audience });

  logout = () => this.http.post('/auth/logout', undefined, { query: { audience } });

  forgotPassword = (email: string) => this.http.post('/auth/password/forgot', { email, audience });

  resetPassword = (token: string, password: string) =>
    this.http.post('/auth/password/reset', { token, password });

  verifyEmail = (token: string) => this.http.post('/auth/verify-email', { token });

  socialLogin = (provider: SocialProvider, idToken: string, displayName?: string) =>
    this.http.post<SignInResult>(`/auth/oauth/${provider}`, {
      idToken,
      displayName,
      audience,
    });

  changePassword = (newPassword: string, currentPassword?: string) =>
    this.http.post(
      '/auth/password/change',
      { newPassword, currentPassword },
      { query: { audience } },
    );

  requestEmailChange = (newEmail: string, password?: string) =>
    this.http.post('/auth/email/change', { newEmail, password, audience }, { query: { audience } });

  confirmEmailChange = (token: string) =>
    this.http.post<{ email: string }>('/auth/email/change/confirm', { token });

  deleteAccount = (password?: string) =>
    this.http.post('/auth/account/delete', { password }, { query: { audience } });
}

export const authService = new AuthService(http);
